import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth";
interface FavoritesResponse {
  favorites: string[];
}
const fetchFavorites = async (): Promise<string[]> => {
  const response = await fetch("/api/user/favorites");
  if (!response.ok) {
    if (response.status === 401) {
      // User not logged in, return empty array
      return [];
    }
    if (response.status === 403) {
      // User doesn't have access to favorites feature, return empty array
      return [];
    }
    throw new Error("Failed to fetch favorites");
  }
  const data: FavoritesResponse = await response.json();
  return data.favorites.map(poolAddress => poolAddress.toLowerCase());
};
export const useFavorites = () => {
  const $ = _c(5);
  const {
    user
  } = useAuth();
  const userId = user?.id;
  let t0;
  if ($[0] !== userId) {
    t0 = ["favorites", userId];
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!userId;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: fetchFavorites,
      enabled: t1,
      staleTime: 60000,
      gcTime: 600000,
      placeholderData: keepPreviousData
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
};